import AccountContent from './AccountContent/AccountContent'
import classes from './Account.module.scss'

const Account = () => {

    return (
        <div className={classes.projectsContainer}>
        
                <AccountContent/>
            </div>
    )
}

export default Account